import { useEffect, useState } from "react";

import CircularProgress from "../circular-progress";

// ----------------------------------------------------------------------

export default function SplashScreen() {
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	if (!mounted) {
		return null;
	}

	return (
		<div className="flex size-full flex-col items-center justify-center space-y-4">
			<img alt="splash-logo" className="size-36" src="/logo.svg" />
			<CircularProgress />
		</div>
	);
}
